<template>
  <ul class="ps-0 pe-0 m-0">
    <li
      class="list-item"
      v-for="(item, _) in items"
      :key="_"
      :style="{ marginBottom: gap }"
    >
      <img
        class="me-1"
        style="margin-top: -2px"
        :src="useAsset(item?.icon ?? 'img/icons/checked_circle.svg')"
        alt="check"
      />
      <span>
        {{ item?.text }}
      </span>
    </li>
  </ul>
</template>

<script setup lang="ts">
import useAsset from "@/apps/credit-line/helpers/useAsset";
type BulletItem = {
  text: string;
  icon?: string;
};

defineProps({
  items: {
    type: Array as () => BulletItem[],
    required: true,
  },
  gap: {
    type: String,
    default: "3.33px",
  },
});
</script>

<style lang="scss" scoped>
ul {
  list-style: none;
}

.list-item {
  display: grid;
  grid-template-columns: 10% 90%;
  grid-template-rows: 100%;
  align-items: start;
  & span {
    text-align: start;
    margin-top: -1px;
    padding-top: 0;
    color: var(--text-grey-dark, #666);
    font-feature-settings: "liga" off, "clig" off;
    font-family: Inter, serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 21px; /* 150% */
  }
}
</style>
